import React from "react";
import BarChart from "../BarChart/BarChart";

const FinancialReportingBarChart = () => {
  return <BarChart />;
};

export default FinancialReportingBarChart;
